<template>
  <n-config-provider :locale="NaiveUILocale.locale" :date-locale="NaiveUILocale.dateLocale" :theme="globalStore.getProviderTheme()" :theme-overrides="themeOverrides">
    <n-loading-bar-provider>
      <n-dialog-provider>
        <n-modal-provider>
          <n-notification-provider placement="bottom">
            <n-message-provider>
              <Index/>
            </n-message-provider>
          </n-notification-provider>
        </n-modal-provider>
      </n-dialog-provider>
    </n-loading-bar-provider>

    <n-global-style />
  </n-config-provider>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import {GlobalThemeOverrides,zhCN, dateZhCN,enUS,dateEnUS} from "naive-ui";
import {useGlobalConfigStore} from "@/stores";
import {useThemeTokenInjector} from "@/hooks";
import {createThemeColorTokens} from "@/utils";
import Index from "@/views/index.vue";

const globalStore = useGlobalConfigStore();

// 把主色派生为 CSS 变量注入到 document 根节点，供全站 var(--puppy-*) 消费。
useThemeTokenInjector();

const NaiveUILocale = computed(() => {
  switch(globalStore.locale){
    case 'zh-CN':
    default:
      return {
        locale:zhCN,
        dateLocale:dateZhCN
      }
    case 'en-US':
      return {
        locale:enUS,
        dateLocale:dateEnUS
      }
  }
});
const themeOverrides = computed<GlobalThemeOverrides>(() => {
  const mainColor = globalStore.mainColor as IConfig.Color;
  const tokens = createThemeColorTokens(mainColor);

  return {
    common: {
      primaryColor: tokens.primary,
      primaryColorHover: tokens.hover,
      primaryColorPressed: tokens.pressed,
      primaryColorSuppl: tokens.suppl,
      successColor: tokens.primary,
      successColorHover: tokens.hover,
      successColorPressed: tokens.pressed,
      successColorSuppl: tokens.suppl,
      fontWeightStrong: '600'
    }
  }
})
</script>

<style>
.n-config-provider {
  width: 100%;
  height: 100%;
}
</style>
